import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { DocumentUploadButtonComponent } from "./document-upload-button/document-upload-button.component";
import { DocumentUploadListComponent } from "./document-upload-list/document-upload-list.component";
import { DocumentUploadComponent } from "./document-upload/document-upload.component";
import { UploadModalComponent } from "./upload-modal/upload-modal.component";
import { AppMatModule } from "../../app-mat.module";
import { ReactiveFormsModule } from "@angular/forms";
import { TagPickerComponent } from "../tag-picker/tag-picker.component";
import { DocumentUploadDragAndDropComponent } from "./document-upload-drag-and-drop/document-upload-drag-and-drop.component";
import { FileDndDirective } from "../../directives/file-dnd.directive";
import { DocumentUploadProgressComponent } from "./document-upload-drag-and-drop/document-upload-progress/document-upload-progress.component";
import { UploadModalShortComponent } from "./upload-modal-short/upload-modal-short.component";
import { DocumentUploadControlComponent } from "./document-upload-control/document-upload-control.component";

@NgModule({
  declarations: [
    DocumentUploadButtonComponent,
    DocumentUploadDragAndDropComponent,
    DocumentUploadListComponent,
    DocumentUploadComponent,
    UploadModalComponent,
    UploadModalShortComponent,
    TagPickerComponent,
    FileDndDirective,
    DocumentUploadProgressComponent,
    DocumentUploadControlComponent,
  ],
  imports: [
    CommonModule,
    AppMatModule,
    ReactiveFormsModule,
  ],
  exports: [
    DocumentUploadButtonComponent,
    DocumentUploadDragAndDropComponent,
    DocumentUploadListComponent,
    DocumentUploadComponent,
    UploadModalShortComponent,
    TagPickerComponent,
    FileDndDirective,
    DocumentUploadProgressComponent,
    DocumentUploadControlComponent,
  ],
})
export class DocumentUploadModule {}
